export function validateEmail(email: string): boolean {
  if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    return true; // valid
  }
  return false; // is not valid
}
